<div class="notification-dialog-container">
  <p class="title">{{data.title}}</p>
  <p id="notificación-dialog-aceptar"  class="message">{{data.message}}</p>
  <div class="actions">
    <button (click)="closeAction(true)" mat-raised-button class="accept"><span>Aceptar</span></button>
  </div>
</div>
